<template lang="pug">
  table#tbItemsSmall.table.is-responsive
    thead
      tr
        th.has-text-centered #
        th.has-text-centered Descripción
        th.has-text-centered Ubicación
    tbody
      tr(:class="i.id_cot === cotSel.id_cot ? 'selected': ''" v-for="(i, index) in cotizaciones")
        td
          span.tag.is-black {{ index + 1 }}
          | &nbsp
          a.button.is-small.is-rounded(:href='getRuta(i.file)' target='_blank' rel='noreferer noopener')
            i.fas.fa-file-pdf
        td
          a.button.is-small.is-rounded.is-noBordered(@click='showHideData(i)')
            i.fas.fa-angle-right 
          | &nbsp{{ i.descripcion }}
        td {{ i.ubicacion }}
</template>

<script>
  export default {
    name: 'ListCot_PresupuestosSmall',
    props: {
      cotizaciones: {
        type: Array,
        default: () => []
      },
      cotSel: {
        type: Object,
        default: () => {}
      },
    },
    methods: {
      getRuta(ruta) {
        const currentUrl = window.location.hostname

        return `https://${currentUrl}${ruta}`
      },
      hideData() {
        this.$emit('hideCotData', true)
      },
      getClass() {
        console.log(i.id_cot === cotSel.id_cot ? 'selected': '')
        return i.id_cot === cotSel.id_cot ? 'selected': ''
      },
      showHideData(cot) {
        this.$emit('showCotData', cot)
      }
    },
  }
</script>

<style lang="scss" scoped>
  .selected {
    background-color: #d9d9d9;
  }
  .is-noBordered {
    border: none;
  }
</style>


// WEBPACK FOOTER //
// src/components/presupuestos_Componentes/componentes/ListCot_PresupuestosSmall.vue